
import { Vue } from "vue-class-component";

export default class PrinterV2 extends Vue {}
